import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxCommentMenuComponent } from './comment-menu.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { CommentReactionsModule } from '../comment-reactions/comment-reactions.module';
import { ViewersOverlayComponent } from './comment-viewers/comment-viewers.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		CommentReactionsModule,
		MatProgressSpinnerModule
	],
	declarations: [
		NgxCommentMenuComponent,
		ViewersOverlayComponent
	],
	exports: [
		NgxCommentMenuComponent,
		ViewersOverlayComponent
	]
})
export class CommentMenuModule {}
